import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'The ShipSticks Guarantee',
  description:
    'Discover the ShipSticks guarantee—door-to-door golf club shipping backed by ' +
    'on-time delivery, dedicated support, and flexible travel options.',
  alternates: {
    canonical: 'https://www.shipsticks.com/guarantee',
  },
}

export default metadata
